module.exports = __webpack_public_path__ + "media/images/favicon-c12a6c9e74da243f6d45e0155743e42d.ico";